import { useEffect, useState } from "react";
import titleCaseString from "../../../utils/titleCaseUtils";
import useUpdate from "../../../hooks/useUpdate";
import DateFormatter from "../../../utils/dateFormatterUtils";
import Swal from "sweetalert2";
import LoadingAnimation from "../../../components/Loading";
import ImageGallery from "react-image-gallery";


/* HOOKS */
import useCachedTransactions from "../../../hooks/useFetchWithCache";

/* CSS */ 
import "../../../styles/pages/page-profile.css";
import "../../../styles/image-gallery.css";
import { height, width } from "@mui/system";
import { isValidFile, getFilePath } from "../../../utils/imageValidatorUtils";

/* CUSTOM SERVICES */
import apiRequest from "../../../services/apiService";



import { useAuth } from "../../../contexts/AuthContext";


import { format } from "date-fns";

import useSendSMS from '../../../hooks/useSendSMS';
import useSendEmail from "../../../hooks/useSendEmail";
import useSendPushNotification from "../../../hooks/useSendPushNotification";
import Maps from "../../../components/Maps";


/* TABS */ 
import TabTransaction from "./transaction_details_tab/tab_transaction";
import TabParticipants from "./transaction_details_tab/tab_participants";
import TabOthers from "./transaction_details_tab/tab_others";
import Lightbox from "yet-another-react-lightbox";
import TabCertificate from "./transaction_details_tab/tab_certificate";
import TabVideo from "./transaction_details_tab/tab_video";




const NotarialBookDetails = ({
  selectedItem
}) =>
  {

  console.log("ggkudasai",selectedItem);



  const defaultImagePath = "/iusevolutione/assets/img/no-attachment.svg";

  // Check if the selected item files are valid
  const attachmentIsValid = isValidFile(selectedItem?.document_attachment);
  const signatureIsValid  = isValidFile(selectedItem?.signature_file);
  const iDIsValid         = isValidFile( selectedItem?.attachment_id_file);

  const images = [
    // {
    //   original   : getFilePath(selectedItem?.document_attachment, defaultImagePath),
    //   thumbnail  : getFilePath(selectedItem?.document_attachment, defaultImagePath),
    //   originalAlt: attachmentIsValid ? "Uploaded Document(s)" : "No Uploaded Document(s)",
    //   description: attachmentIsValid ? "Uploaded Document(s)" : "No Uploaded Document(s)",
    // },
    {
      original     : getFilePath(selectedItem?.signature_file, defaultImagePath),
      thumbnail    : getFilePath(selectedItem?.signature_file, defaultImagePath),
      originalAlt  : signatureIsValid ? "Signature" : "No Signature",
      originalTitle: signatureIsValid ? "Signature" : "No Signature",
      description  : signatureIsValid ? "Signature" : "No Signature",
    },
    {
      original   : getFilePath(selectedItem?.attachment_id_file, defaultImagePath),
      thumbnail  : getFilePath(selectedItem?.attachment_id_file, defaultImagePath),
      originalAlt: iDIsValid ? "Government ID" : "No Government ID Image",
      description: iDIsValid ? "Government ID" : "No Government ID Image",
    },
  ];


  const { sendSMS, response, error }                            = useSendSMS();
  const { sendEmail, responseEmail, errorEmail }                = useSendEmail();
  const { sendPushNotification, response:responsePushNotif, error:errorPushNotif } = useSendPushNotification();



  const updateTransactionStatus = async(newStatus) => {
    await sendPushNotification(selectedItem.registration_id, "", "Application Accepted", `Your schedule is on: ${''} at ${''}`, "Schedule", "notification_user" );
  };



   

 
   const [activeTab, setActiveTab] = useState('transaction');

    const tabs = [
      { id: 'transaction', label: 'Details' },
      { id: 'participants', label: 'Participants' },
      { id: 'others', label: 'Others' },
      { id: 'acknowledgment', label: 'Certificate' },
      { id: 'video', label: 'Video File' },
    ];

    const renderContent = () => {
      switch (activeTab) {
        case 'transaction':
          return <TabTransaction selectedItem={selectedItem} />;
        case 'participants':
          return <TabParticipants selectedItem={selectedItem} />;
        case 'others':
          return <TabOthers selectedItem={selectedItem} />;
        case 'acknowledgment':
          return <TabCertificate selectedItem={selectedItem} />;
        case 'video':
          return <TabVideo selectedItem={selectedItem} />;
        default:
          return null;
      }
    };



  const [index, setIndex] = useState(-1);
  const profileImage = [
    {
      src: selectedItem.user_details?.verification_profile_photo ?? selectedItem?.principal_image,
      title: "1ST PARTY VALID ID",
    }]
  

  return (
    <>

  
      {selectedItem && (
        <>
          <div className="container-xxl flex-grow-1 p-0 m-0">
            <div className="col-12">
              <div className="card mb-4">
                <div className="user-profile-header-banner">

                    <Maps location={selectedItem.user_location} />


                  {/* {selectedItem.user_location ?
                  :
                   <img src="/iusevolutione/assets/img/pages/profile-banner.png" alt="Banner" className="rounded-top" /> 
                  } */}
                </div>
                <div className="user-profile-header d-flex flex-column flex-sm-row text-sm-start text-center mb-4 z-1">
                  <div className="flex-shrink-0 mt-n2 mx-sm-0 mx-auto">
                    <img
                      src={(selectedItem.user_details?.verification_profile_photo ?? selectedItem?.principal_image) || "/iusevolutione/assets/img/no-attachment.svg"}
                      alt="user"
                      // className="d-block h-auto ms-0 ms-sm-4 rounded user-profile-img"
                      style={{ cursor: "pointer", maxHeight: 250,minHeight:250,width:250,objectFit:"cover" }}
                      className="d-block h-auto ms-0 ms-sm-4  hover-zoom rounded user-profile-img"
                      onClick={() => setIndex(0)}

                    />

                    <Lightbox
                          open={index >= 0}
                          close={() => setIndex(-1)}
                          slides={profileImage} 
                          index={index}
                          onIndexChange={setIndex}
                          plugins={[]}
                      />


                  </div>
                  <div className="flex-grow-1 mt-3 mt-sm-5">
                    <div className="d-flex  flex-column gap-4">
                      <div className="user-profile-info ms-4">
                        <h4 className="mb-1"> {selectedItem?.full_name?.toUpperCase()} </h4>
                        <ul className="list-inline mb-0 d-flex align-items-center flex-wrap justify-content-sm-start justify-content-center gap-2">
                          {/* <li className="list-inline-item fw-medium"><i className="bx bx-envelope" /> {selectedItem.user_transacted.email}</li> */}
                          <li className="list-inline-item fw-medium">
                            <i className="bx bx-map" />
                            <span>
                              {`
                                ${titleCaseString(selectedItem?.country || "Philippines")},
                                ${titleCaseString(selectedItem?.province)},
                                ${titleCaseString(selectedItem?.city)},
                                Brgy. ${titleCaseString(selectedItem?.barangay ?? "")}
                              `}
                            </span>
                          </li>
                        </ul>

              
                       
                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <div className="card mb-4">
                  {selectedItem &&
                    <div className="card-body">
                      <small className="text-muted text-uppercase">
                        User Information
                      </small>
                      <ul className="list-unstyled mb-4 mt-3">
                        <li className="d-flex align-items-center mb-3">
                          <i className="bx bx-user" />
                          <span className="fw-medium mx-2">Fullname:</span>{" "}
                          <span>
                            {titleCaseString(
                              selectedItem.first_name?.toUpperCase() +
                              " " +
                              selectedItem.last_name?.toUpperCase()
                            )}
                          </span>
                        </li>

                        <li className="d-flex align-items-center mb-3">
                          <i className="bx bx-male-female" />
                          <span className="fw-medium mx-2">Gender:</span>{" "}
                          <span>{titleCaseString(selectedItem.gender)}</span>
                        </li>

                        <li className="d-flex align-items-center mb-3">
                          <i className="bx bx-calendar" />
                          <span className="fw-medium mx-2">Birthdate:</span>{" "}
                          <span>
                            {DateFormatter(
                              selectedItem.birth_date,
                              "MM DD, YYYY"
                            )}
                          </span>
                        </li>

                      </ul>
                      <small className="text-muted text-uppercase">
                        Contacts
                      </small>
                      <ul className="list-unstyled mt-3">
                        <li className="d-flex align-items-center mb-3">
                          <i className="bx bx-phone" />
                          <span className="fw-medium mx-2">Contact:</span>
                          <span>{selectedItem.contact_number}</span>
                        </li>
                        <li className="d-flex align-items-center mb-3">
                          <i className="bx bx-envelope" />
                          <span className="fw-medium mx-2">Email:</span>
                          <span>{selectedItem.email}</span>
                        </li>
                      </ul>
                    </div>
                  }

                </div>

                <div className="card">
                  <div className="card-body">
                    <small className="text-muted text-uppercase">
                      ID AND Attachments
                    </small>

                    <ul className="list-unstyled mb-4 mt-3">
                      <li className="d-flex align-items-center mb-3">
                        <i className="bx bx-id-card" />
                        <span className="fw-medium mx-2">ID:</span>{" "}
                        <span>{selectedItem?.attachment_id_type}</span>
                      </li>

                      <li className="d-flex align-items-center mb-3">
                        <i className="bx bx-credit-card-front" />
                        <span className="fw-medium mx-2">ID Number:</span>{" "}
                        <span>{selectedItem?.attachment_id_number}</span>
                      </li>

                      <li className="d-flex align-items-center mb-3 w-100" style={{ minHeight: 375 }} >

                        <ImageGallery
                          showPlayButton={false}
                          style={{ height: 100 }}
                          items={images}
                          showThumbnails={false}
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-8">

              

                       <div>
                        {/* Tab Navigation */}
                        <ul className="nav nav-tabs nav-fill tabs-line" role="tablist">
                          {tabs.map((tab) => (
                            <li className="nav-item " key={tab.id}>
                              <button
                                type="button"
                                className={`border rounded nav-link ${activeTab === tab.id ? 'active' : ''}`}
                                onClick={() => setActiveTab(tab.id)}
                              >
                                {tab.label}
                              </button>
                            </li>
                          ))}
                        </ul>

                        {/* Tab Content */}
                        <div className="tab-content border p-0 mt-2">
                          {renderContent()}
                        </div>
                      </div>
                     
                





      




                <div className="card card-action d-none">
                  <div className="card-header align-items-center pb-2">
                    <h5 className="card-action-title mb-0">
                      <i className="bx bx-info-circle me-2" />
                      Transaction Information
                    </h5>
                  </div>

                  <div className="card-body">
                    <ul className="list-unstyled mb-4 mt-3">
                      <li className="d-flex align-items-center mb-3">
                        <i className="bx bx-check" />
                        <span className="fw-medium mx-2">Transaction ID :</span>
                        <span>
                          {selectedItem.transaction_id} (
                          {titleCaseString(selectedItem.transaction_status)})
                        </span>
                      </li>

                      <li className="d-flex align-items-center mb-3">
                        <i className="bx bx-calendar-alt" />{" "}
                        <span className="fw-medium mx-2">Date Created :</span>{" "}
                        {DateFormatter(
                          selectedItem.date_created,
                          "MM DD, YYYY"
                        )}
                      </li>

                      <li className="d-flex align-items-center mb-3">
                        <i className="bx bx-flag" />
                        <span className="fw-medium mx-2">
                          Inside the Philippines :
                        </span>
                        <span>
                          {titleCaseString(selectedItem?.is_inside_philippines)}
                        </span>
                      </li>

                      <li className="d-flex align-items-center mb-3">
                        <i className="bx bxs-file-doc" />
                        <span className="fw-medium mx-2">
                          Document Type :
                        </span>
                        <span>
                          {selectedItem.document_name?.toUpperCase() === "TITLE YOUR DOCUMENT" ? titleCaseString(selectedItem.document_title) : titleCaseString(selectedItem.document_name)}
                        </span>
                      </li>

                      <li className="d-flex align-items-center mb-3">
                        <i className="bx bx-dollar-circle" />
                        <span className="fw-medium mx-2">Price :</span>{" "}
                        <span>
                          {selectedItem.document_price} -{" "}
                          {selectedItem.transaction_payment_status}{" "}
                        </span>
                        <span className="badge bg-label-success">
                          Ref#: {selectedItem.reference_number}
                        </span>
                      </li>
                    </ul>

                 

                    <small className="text-muted text-uppercase">
                      Miscellaneous Information
                    </small>

                    <ul className="list-unstyled mb-4 mt-3">
                      <li className="d-flex align-items-center mb-3">
                        <span className="badge badge-center rounded-pill bg-label-danger">
                          <i className="bx bx-question-mark" />
                        </span>
                        <span className="fw-medium mx-2"> Will the notarized document be used in the Philippines or abroad ?
                          <p className="fw-bolder d-inline ms-2 text-primary">{selectedItem?.question_1}</p>
                        </span>
                      </li>



                      <li className="d-flex align-items-center mb-3">
                        <span className="badge badge-center rounded-pill bg-label-danger">
                          <i className="bx bx-question-mark" />
                        </span>
                        <span className="fw-medium mx-2"> Is your document signed by all signatories by hand (wet-signed) ?
                          <p className="fw-bolder d-inline ms-2 text-primary">{selectedItem?.question_2}</p>
                        </span>

                      </li>

                      <li className="d-flex align-items-center mb-3">
                        <span className="badge badge-center rounded-pill bg-label-danger">
                          <i className="bx bx-question-mark" />
                        </span>
                        <span className="fw-medium mx-2"> Were the signatories in the Philippines when they signed the document ?
                          <p className="fw-bolder d-inline ms-2 text-primary">{selectedItem?.question_3}</p>
                        </span>
                      </li>

                      <li className="d-flex align-items-center mb-3">
                        <span className="badge badge-center rounded-pill bg-label-danger">
                          <i className="bx bx-question-mark" />
                        </span>
                        <span className="fw-medium mx-2"> Are the signatories currently in the Philippines?
                          <p className="fw-bolder d-inline ms-2 text-primary">{selectedItem?.question_4}</p>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>

                
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default NotarialBookDetails;
